import axios from 'axios';
import * as shipment_urls from '../../../urls/api-shipments/admin';

function getShipmentApiErrorMessage(error, fallbackMessage) {
  if (!error.response) {
    return null;
  }

  const responseData = error.response.data;

  if (typeof responseData === 'string') {
    if (error.response.status === 404 && responseData.includes('Cannot PUT')) {
      return 'Arrival override is not available in this environment yet. The shipments API needs the latest deployment.';
    }

    return fallbackMessage;
  }

  return responseData.message || responseData.error || fallbackMessage;
}

export async function CompleteOrder(shipmentId, orderId, options = {}) {
  try {
    const response = await axios({
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'content-type': 'application/json'
      },
      url: shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/orders/' + orderId + '/complete',
      data: options
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw new Error(getShipmentApiErrorMessage(error, 'Unable to complete the order'));
    }

    throw error;
  }
}

export async function OverrideOrderArrival(shipmentId, orderId, options = {}) {
  try {
    const response = await axios({
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'content-type': 'application/json'
      },
      url: shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/orders/' + orderId + '/arrival-override',
      data: options
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw new Error(getShipmentApiErrorMessage(error, 'Unable to override arrival for the order'));
    }

    throw error;
  }
}

export async function OverrideShipmentArrival(shipmentId, options = {}) {
  try {
    const response = await axios({
      method: 'put',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'content-type': 'application/json'
      },
      url: shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/arrival-override',
      data: options
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw new Error(getShipmentApiErrorMessage(error, 'Unable to override arrival for the shipment'));
    }

    throw error;
  }
}

async function runArrivalOverrideRequestAction(method, url, options, fallbackMessage) {
  try {
    const response = await axios({
      method,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'content-type': 'application/json'
      },
      url,
      data: options
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw new Error(getShipmentApiErrorMessage(error, fallbackMessage));
    }

    throw error;
  }
}

export function ClaimOrderArrivalOverrideRequest(shipmentId, orderId, options = {}) {
  return runArrivalOverrideRequestAction('put', shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/orders/' + orderId + '/arrival-override-request/claim', options, 'Unable to claim the order arrival override request');
}

export function ReleaseOrderArrivalOverrideRequest(shipmentId, orderId, options = {}) {
  return runArrivalOverrideRequestAction('put', shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/orders/' + orderId + '/arrival-override-request/release', options, 'Unable to release the order arrival override request');
}

export function DenyOrderArrivalOverrideRequest(shipmentId, orderId, options = {}) {
  return runArrivalOverrideRequestAction('put', shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/orders/' + orderId + '/arrival-override-request/deny', options, 'Unable to deny the order arrival override request');
}

export function ClaimShipmentArrivalOverrideRequest(shipmentId, options = {}) {
  return runArrivalOverrideRequestAction('put', shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/arrival-override-request/claim', options, 'Unable to claim the shipment arrival override request');
}

export function ReleaseShipmentArrivalOverrideRequest(shipmentId, options = {}) {
  return runArrivalOverrideRequestAction('put', shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/arrival-override-request/release', options, 'Unable to release the shipment arrival override request');
}

export function DenyShipmentArrivalOverrideRequest(shipmentId, options = {}) {
  return runArrivalOverrideRequestAction('put', shipment_urls.shipmentHost + '/shipments/' + shipmentId + '/arrival-override-request/deny', options, 'Unable to deny the shipment arrival override request');
}
